/* import __COLOCATED_TEMPLATE__ from './step-analysis-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();